import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VacatureService {

  constructor(private http:HttpClient) { }

  getVacatures() {
    return this.http.get<any>(`${environment.apiBaseUrl}/vacatures?populate=*`);
  }

  getVacature(id:string) {
    return this.http.get<any>(`${environment.apiBaseUrl}/vacatures?filters[id][$eq]=${id}&populate=*`);
  }

  populateVacature(data:any) {
    let vac = data;
    vac.id = data.id;
    vac.vestigingen = this.parse(vac.vestigingen);

    return vac;
  }

  parse(coll:any) {
    let list:any = [];
    for(let e of coll) {
      let obj = e;
      obj.id = e.id;
      list.push(obj);
    }
    return list;
  }
}
